import { render, staticRenderFns } from "./ScheduleRecommendationTable.vue?vue&type=template&id=64fae8a7"
import script from "./ScheduleRecommendationTable.vue?vue&type=script&lang=js"
export * from "./ScheduleRecommendationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports